module.exports = __webpack_public_path__ + "img/close.e165a7a4.svg";